import React from 'react'
import { Form } from 'antd';
import { Grid, TextField,Snackbar,FormControlLabel } from '@material-ui/core';
import MySnackbarContentWrapper from "../../../../components/SnackBar";
import FileBase64 from 'react-file-base64';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

class myUploadReceiptForm extends React.Component {
  
  state = {
    file: [],
    confirmDirty: false,
    autoCompleteResult: [],
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing...",
    paymentDate : this.props.paymentDate ? this.props.paymentDate : new Date()
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let variables = 
        {
          publisherId: this.props.publisherId, 
          referenceDate: this.props.referenceDate, 
          paymentDate: new Date(this.state.paymentDate), 
          paymentValue: parseFloat(values.paymentValue), 
          receiptLocation: this.state.file && this.state.file.base64 ? 
          this.state.file.base64 : this.props.receiptLocation,
          USDValue: this.props.USDValue ? parseFloat(this.props.USDValue) : 1
        };

        this.props.query_f({ variables: variables }).then(result =>{
          this.setStateValues(true,"success","Action executed with success!");
          this.props.form.resetFields();
          if(this.props.onCancel){
            this.props.onCancel();
          }
          localStorage.setItem('adireto-drawer-open', false);
        }, error=>{
          this.setStateValues(true,"error","Action executed with error!");          
        });
      }
      else{
        this.setStateValues(true,"error","Form validation failed!");  
      }
    });
  }

  
  handlePaymentDateChange= (event) => {
    this.setState({ paymentDate: event });
  };
  
  // Callback~
  getFiles(file){
    var FileSize = file.file.size / 1024 / 1024; // in MB
    if (FileSize > 1)
      this.setStateValues(true,"error","File must be smaller than 1MB");
    else
      this.setState({ file: file })
  }
  render() {

    const { getFieldDecorator } = this.props.form;

    return (
      <>
      <h3>{this.props.publisherName} {this.props.referenceDate}</h3>
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage}/>
        </Snackbar>
        <Grid container spacing={0}>
        <Grid item xs={12}>
          {getFieldDecorator('paymentDate',
           {
            initialValue: (this.props.paymentDate || ''),
            rules: [{ required: false, message: 'Please input your payment date!', whitespace: true }],
          })(
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker disableToolbar variant="inline" format="dd/MM/yyyy" margin="normal" id="date-picker-inline" label="Payment Date"
              style={{ marginTop : 13 }} value={this.state.paymentDate} onChange={this.handlePaymentDateChange} KeyboardButtonProps={{ "aria-label": "change date" }}
            />
            </MuiPickersUtilsProvider>
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('paymentValue',
           {
            initialValue: (this.props.paymentValue || '')
          })(
            <TextField
            id="paymentValue"
            label="Payment Value $"
            color="primary"
            fullWidth
            style={{ marginTop : 13 }}
            InputLabelProps={{
              shrink : true,
            }}
            placeholder="Payment value $"
          />
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('USDValue',
           {
            initialValue: (this.props.USDValue || '')
          })(
            <TextField
            id="USDValue"
            label="USD Value"
            color="primary"
            fullWidth
            style={{ marginTop : 13 }}
            InputLabelProps={{
              shrink : true,
            }}
            placeholder="USD Value"
          />
          )}
        </Grid>
        <Grid item xs={12}>
            <br/>
            <a href={this.props.receiptLocation} target="_blank" rel="noopener noreferrer">Receipt</a> (1MB Max)
            <br/>
            <FormControlLabel
            control={
                <FileBase64
                multiple={ false }
                onDone={ this.getFiles.bind(this) } />
            }
            style={{marginTop : 10, marginLeft: "auto"}}/>
        </Grid>
        </Grid>
        </form>
      </>
    );
  }
}

const UploadReceiptForm = Form.create()(myUploadReceiptForm);

export default UploadReceiptForm